import FollowerDetails from './FollowerDetails';
import Import from './import';

const followers = {
  title: 'Seguidores',
  fields: {
    name: 'Nombre',
    subscribed: 'Suscrito',
    followed: 'Seguidor',
    phone: 'Teléfono',
    recent_order: 'Pedido reciente',
    total_orders: 'Pedidos totales',
    birthday: 'Cumpleaños',
    google_review: 'Reseña en Google',
    marketing_subscription_source: 'Suscrito desde',
    loyalty_points: 'Fidelidad',
  },
  empty_list: 'Sin clientes aún',
  yes: 'Sí',
  no: 'No',
  buttons: {
    import: 'Importar',
    export: 'Exportar',
  },
  toasts: {
    failed_to_load_data: 'Error al cargar los datos',
  },
  labels: {
    followed_since_date: 'Desde {{date}}',
  },
};

export default {
  ...followers,
  FollowerDetails,
  Import,
};
